export default __webpack_public_path__ + "static/media/coming_soon.9fa28db6.svg";